import { Css, useTestIds } from "@homebound/beam";
import { ApproversDetail } from "src/routes/components/Approval/ApproverDetail";
import { ReviewStep_ApproverFragment } from "src/routes/projects/change-events/guided/workflows/sharedSteps/ReviewStep.generated";

type ReviewApproversProps = {
  approvers: ReviewStep_ApproverFragment[];
  /** What the project calls its client, i.e. "Homeowner", used as the role for client approvers. */
  clientNoun: string;
};

export function ReviewApprovers(props: ReviewApproversProps) {
  const { approvers, clientNoun } = props;
  const tid = useTestIds(props, "approvals");
  const rowTid = useTestIds({});

  if (approvers.isEmpty) {
    return (
      <div css={Css.sm.gray600.$} {...tid.empty}>
        This change event is currently predicted to have no approvers and will auto-accept.
      </div>
    );
  }

  return (
    <div css={Css.df.fdc.gap1.$} {...tid}>
      {approvers.map((user) => (
        <div key={user.id} css={Css.df.aic.gap1.$} {...tid.approver}>
          <div css={Css.fg1.$}>
            <ApproversDetail approver={{ user }} />
          </div>
          <span css={Css.sm.gray700.$} {...rowTid.role}>
            {approverRole(user, clientNoun)}
          </span>
        </div>
      ))}
    </div>
  );
}

/** The hat each approver is wearing, i.e. their project role, their trade partner, or the client noun. */
function approverRole(approver: ReviewStep_ApproverFragment, clientNoun: string) {
  switch (approver.__typename) {
    case "InternalUser":
      return approver.projectRoleDetail?.name;
    case "TradePartnerUser":
      return approver.tradePartner.name;
    default:
      return clientNoun;
  }
}
